<template>
    <div class="shop-wishlist">
		<shop-headline :headline="$t('wishlist.wishlist')" icon="star" />
        <template v-if="isEmpty">
            <p v-html="$t('wishlist.isEmpty')"></p>
        </template>
        <template v-else>
            <shop-section v-if="!authenticated">
                <shop-login :buttons="buttons">
                    <template>
                        <p v-html="$t('wishlist.login.body')"></p>
                    </template>
                </shop-login>
            </shop-section>
            <template v-for="(section, sectionIndex) in wishlistData.items">
                <div :id="section.category">
                    <h2 class='headline-2'>
                        <span>{{section.sectionTitle}}</span>

                        <template v-if="section.category === 'products' && showRoomdesignerButton(sectionIndex)">
                            <span class="button-wrapper fill--xs spacer--top-none right">
                                <button class="button button--primary icon--before icon--roomdesigner" @click="openRoomdesigner(sectionIndex)">{{$t('wishlist.toRoomDesigner')}}</button>
                            </span>
                        </template>
                    </h2>
                    <div v-if="section.howToOrder"><p>{{section.howToOrder}}</p></div>
                    <template v-if="section.category === 'decorset'">
                        <template v-for="(decorset, decorsetIndex) in section.items">
                            <div class="row global-edit">
                                <div class="col-12 col-md-6">
                                    <div class="global-edit--edit" v-if="edit.sectionIndex === sectionIndex && edit.decorsetIndex === decorsetIndex">
                                        <div class="global-edit--form form__input--with-button">
                                            <input type="text" class="form__input form__input--text" v-model="edit.inputvalue" />
                                            <button class="button button--secondary button--icon icon--before icon--close" aria-label='discard' @click="decorsetCloseEdit" />
                                        </div>
                                        <button class="button button--ghost icon--before icon--save" @click="decorsetSaveEdit">
                                            <span>{{ $t('wishlist.save') }}</span>
                                        </button>
                                    </div>
                                    <div class="global-edit--editable" v-else>
                                        <h3 class="headline headline--center-v headline--editable">
                                            {{decorset.name}}
                                            <button class="button button--secondary button--icon icon--before icon--edit icon--small" aria-label='edit' @click="decorsetOpenEdit(decorset, sectionIndex, decorsetIndex)" />
                                        </h3>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="button-wrapper spaced right">
                                        <button v-if="showRoomdesignerButton(sectionIndex, decorsetIndex)" class="button button--primary icon--before icon--roomdesigner" @click="openRoomdesigner(sectionIndex, decorsetIndex)">{{$t('wishlist.toRoomDesigner')}}</button>
                                        <button class="button button--secondary button--icon icon--before icon--trash" @click="remove(decorset, sectionIndex, decorsetIndex)" />
                                    </div>
                                </div>
                            </div>
                            <div class="row shop-wishlist__decorset">
                                <template v-for="decor in decorset.decors">
                                    <global-inline-tile :image="decor.image_src" :image-link="decor.detail_link" :title="'<b>' + decor.title + '</b>'" :subtitle="decor.subtitle" class="col-6 col-md-4 col-lg-3" />
                                </template>
                            </div>
                        </template>
                    </template>
                    <template v-else-if="section.category === 'product_samples'">
                        <PimProductTableListSamples :samples="section.items">
                            <template v-slot:actions="actionProps">
                                <div class="button-wrapper spaced v-center right">
                                    <CartButton :entity="actionProps.item" />
                                    <button class="button button--secondary button--icon icon--before icon--trash" @click="remove(actionProps.item, sectionIndex, actionProps.index)" :title="$t('wishlist.remove')"></button>
                                </div>
                            </template>
                        </PimProductTableListSamples>
                    </template>
                    <template v-else-if="section.category === 'material_samples'">
                        <PimProductTableListInformationMaterial :materials="section.items">
                            <template v-slot:actions="actionProps">
                                <div class="button-wrapper spaced v-center right">
                                    <CartButton :entity="actionProps.item" />
                                    <button class="button button--secondary button--icon icon--before icon--trash" @click="remove(actionProps.item, sectionIndex, actionProps.index)" :title="$t('wishlist.remove')"></button>
                                </div>
                            </template>
                        </PimProductTableListInformationMaterial>
                    </template>
                    <template v-else-if="section.category === 'products'">
                        <PimProductTableListProducts :products="section.items">
                            <template v-slot:actions="actionProps">
                                <div class="button-wrapper spaced v-center right">
                                    <button class="button button--secondary button--icon icon--before icon--trash" @click="remove(actionProps.item, sectionIndex, actionProps.index)" :title="$t('wishlist.remove')"></button>
                                </div>
                            </template>
                        </PimProductTableListProducts>
                    </template>
                    <template v-else>
                        Unsupported Section:<br>
                        {{section}}
                    </template>
                </div>
            </template>
        </template>
        <global-roomdesigner-selection v-if="roomdesignerModalData" :initial-data="roomdesignerModalData" />
    </div>
</template>

<script>
import ShopSection from "@shopCheckout/components/shop-section/shop-section.vue";
import ShopCheckoutButton from "@shopCheckout/components/shop-checkout-button/shop-checkout-button";
import ShopInfoBox from "@shopCheckout/components/shop-info-box/shop-info-box";
import ShopTile from "@shopCheckout/components/shop-tile/shop-tile";
import {shopUtilities} from "@global/shop-utilities/shop-utilities";
import {cookieUtils} from "@utilities/cookie-utils/cookie-utils";
import ShopLogin from "@shopCheckout/components/shop-login/shop-login";
import ShopHeadline from "@shopCheckout/components/shop-headline/shop-headline";
import GlobalAccordion from "../../../../../../global/global-elements/global-accordion/global-accordion";
import {SalToast} from "@utilities/sal-toast/sal-toast";
import GlobalResponsiveImage from "../../../../../../global/global-elements/global-responsive-image/global-responsive-image";
import GlobalRoomdesignerSelection from '../../../../../../global/global-elements/global-roomdesigner/global-roomdesigner-selection';
import GlobalInlineTile from "@global/global-elements/global-inline-tile/global-inline-tile.vue";
import PimProductTableListSamples from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-samples.vue";
import PimProductTableListInformationMaterial from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-information-material.vue";
import CartButton from "@src/Resources/epim/Partials/Shop/cart-button.vue";
import PimProductTableListProducts from "@src/Resources/epim/Partials/PimProductTableList/pim-product-table-list-products.vue";

export default {
        name: "shop-wishlist",
        components: {
            PimProductTableListProducts,
            CartButton,
            PimProductTableListInformationMaterial,
            PimProductTableListSamples,
            GlobalInlineTile,
            GlobalRoomdesignerSelection,
            GlobalResponsiveImage,
            GlobalAccordion, ShopHeadline, ShopLogin, ShopTile, ShopInfoBox, ShopCheckoutButton, ShopSection },
        data() {
            return {
                wishlistData: {},
                edit: {
                    sectionIndex: -1,
                    decorsetIndex: -1,
                    inputvalue: ''
                },
                accordionStates: [],

                roomdesignerModalData: {}
            }
        },
        watch: {
            'edit.inputvalue': function(newValue) {
                this.edit.inputvalue = newValue.replace(/(\$|#)/g, '');
            }
        },
        computed: {
            wishlistResponsiveImages() {
                return window.wishlistResponsiveImages
            },
            authenticated() {
                return this.$store.getters.authenticated;
            },
            localization() {
                return window.wishlistLocalization;
            },
            buttons() {
                return [
                    { link: this.wishlistData.login, label: this.$t('wishlist.login.login') },
                    { link: this.wishlistData.register, label: this.$t('wishlist.login.register') }
                ]
            },
            isEmpty() {
                return this.wishlistData.items === null || this.wishlistData.items.length === 0
            },
            lang() {
                return this.$store.state.language;
            }
        },
        methods: {
            remove(item, sectionIndex, itemIndex) {
                this.wishlistData["items"][sectionIndex]["items"].splice(itemIndex, 1);

                if (this.wishlistData["items"][sectionIndex]["items"].length === 0) {
                    this.wishlistData["items"].splice(sectionIndex, 1);
                }

                let order_pid = item.order_pid;
                if (!item.order_pid || item.order_pid === '') {
                    order_pid = item.subtype + '#' + item.pim_id
                }

                shopUtilities.remove('wishlist', order_pid, {
                    id: order_pid
                })
            },
            toggleAccordion(accordionIndex) {
                this.$set(this.accordionStates, accordionIndex, !this.accordionStates[accordionIndex])
            },
            decorsetOpenEdit(decorset, sectionIndex, decorsetIndex) {
                if (this.edit.sectionIndex !== -1) {
                    if (!window.toasts) {
                        window.toasts = new SalToast();
                    }
                    window.toasts.createToast(this.$t('wishlist.saveDiscard'), this.edit.inputvalue, window.toasts.types.INFO, {});
                } else {
                    this.edit.sectionIndex = sectionIndex;
                    this.edit.decorsetIndex = decorsetIndex;
                    this.edit.inputvalue = decorset.name;
                }
            },
            decorsetSaveEdit() {
                const oldCookieName = this.wishlistData.items[this.edit.sectionIndex].items[this.edit.decorsetIndex].name
                const oldCookieOrderPid = this.wishlistData.items[this.edit.sectionIndex].items[this.edit.decorsetIndex].order_pid

                const newCookieOrderPid = oldCookieOrderPid.replace(oldCookieName, this.edit.inputvalue)

                const wishlistItems = cookieUtils.decodeCookieValue(cookieUtils.getCookie(`wishlist_${window.market}`));
                this.wishlistData.items[this.edit.sectionIndex].items[this.edit.decorsetIndex].name = this.edit.inputvalue;
                const cookiePosition = wishlistItems.indexOf(oldCookieOrderPid);

                if (cookiePosition !== -1) {
                    wishlistItems[cookiePosition] = newCookieOrderPid
                }

                cookieUtils.setCookie(`wishlist_${window.market}`, wishlistItems.join('$'), window.authenticated ? 0: 30 * cookieUtils.constants.DAYS);
                shopUtilities.broadcastChanges('wishlistedit', {});
                this.decorsetCloseEdit();
            },
            decorsetCloseEdit() {
                this.edit.sectionIndex = -1;
                this.edit.decorsetIndex = -1;
                this.edit.inputvalue = '';
            },
            getRoomDesignerDecorsForSection(sectionIndex, decorSetIndex = -1) {
                let decors = []
                if (sectionIndex >= 0 && decorSetIndex >= 0) {
                    decors = this.wishlistData.items[sectionIndex].items[decorSetIndex].decors
                }
                else if (sectionIndex >= 0) {
                    decors = this.wishlistData.items[sectionIndex].items
                }
                decors = decors.filter((decor) => decor.type === 'P' && decor.subtype === 'decor')

                return decors;
            },
            showRoomdesignerButton(sectionIndex, decorSetIndex = -1) {
                return !!window.roomdesignerUrl && this.getRoomDesignerDecorsForSection(sectionIndex, decorSetIndex).length > 0;
            },
            openRoomdesigner(sectionIndex, decorSetIndex = -1) {
                const decors = this.getRoomDesignerDecorsForSection(sectionIndex, decorSetIndex);
                if (!decors || decors.length === 0) {
                    this.roomdesignerModalData = {}
                    return;
                }
                this.roomdesignerModalData = {
                    data: decors,
                    selectedDecors: decors.map(d => d.title)
                }
            },
            closeRoomdesigner() {
                this.roomdesignerModalData = {}
            }
        },
        beforeMount() {
            this.wishlistData = window.wishlistdata;
        },
        mounted() {
            this.accordionStates = new Array(this.wishlistData.length);
            this.accordionStates[0] = true;
            if (document.location.hash.length > 0) {
                const hashValue = document.location.hash.substr(1);
                const selectedSection = this.wishlistData.items.find(section => section.category === hashValue);
                if (selectedSection) {
                    this.accordionStates[0] = false;
                    this.accordionStates[this.wishlistData.items.indexOf(selectedSection)] = true;
                    this.$nextTick(() => {
                        document.getElementById(hashValue).scrollIntoView();
                    });
                }
            }
        }
    }
</script>

